export enum VERSION_INPUT_TYPE {
  RANGE = "range",
  SPECIFIC = "specific",
}

export type VersionInputOption = {
  type: VERSION_INPUT_TYPE;
  value?: string | null;
};
